module.exports = __webpack_public_path__ + "img/timer.1a6e5978.svg";